export const formatImage = (image?: string | File) => {
    return `http://localhost:4000/${image}`
}